<template>
    <div class="survey-fill mt-page">

        <survey-form :survey-id="surveyId"
                     v-if="$store.state.currentUser.id">
        </survey-form>

    </div>
</template>

<!-- -------------------------------------------------------- -->

<script>
    import Vue from 'vue'

    /**
     * Page for a Participant or Practitioner to edit/complete a Survey
     */
    export default Vue.extend({
        name: 'SurveyFill',
        props: {
            surveyId: Number
        },
    });

</script>

<style lang="scss">
    .survey-fill {
        @media(min-width: 992px) {
            padding-top: 2rem;
        }
    }
</style>
